import { CreateAccountBankAccountValues, CreateAccountDependentValues } from './createAccountValidationSchema';

export const emptyBankAccountRow: CreateAccountBankAccountValues = {
  bank_name: '',
  routing_number: '',
  encryptedAccountNumber: '',
  account_type: '',
  web_site: '',
  is_ach_autopay: false,
  notes: '',
};

export const emptyDependentRow: CreateAccountDependentValues = {
  first_name: '',
  middle_name: '',
  last_name: '',
  encryptedSsn: '',
  birthdate: '',
  dependant_relationship_type: '',
};

export const BUSINESS_ONLY_FIELD_KEYS = [
  'co_industry',
  'co_prior_accountant',
  'co_number_of_employees',
  'co_fiscal_yearend',
  'co_biggest_challenges',
  'co_biz_decision_tools_used',
  'co_expectations',
  'co_tech_accounting',
  'co_tech_expenses',
  'co_tech_time_trackings',
  'co_tech_payroll',
  'co_tech_billpay',
  'encryptedCoEin',
] as const;

export const INDIVIDUAL_ONLY_FIELD_KEYS = [
  'taxpayer_first_name',
  'taxpayer_middle_name',
  'taxpayer_last_name',
  'in_curr_filling_status',
  'encryptedInSelfSsn',
  'in_self_birthdate',
  'in_self_driver_license',
  'in_self_license_issue_date',
  'in_self_license_expiry_date',
  'in_self_license_state',
  'in_sps_first_name',
  'in_sps_middle_name',
  'in_sps_last_name',
  'encryptedInSpsSsn',
  'in_sps_birthdate',
  'in_sps_driver_license',
  'in_sps_license_issue_date',
  'in_sps_license_expiry_date',
  'in_sps_license_state',
  'in_sps_address_line_1',
  'in_sps_address_line_2',
  'in_sps_address_city',
  'in_sps_address_state',
  'in_sps_address_zip',
  'in_sps_address_country',
] as const;
